module.exports = __webpack_public_path__ + "static/media/limbo.4e402a0f.gif";